module.exports = __webpack_public_path__ + "media/images/dummy-main-carousel-31958c401326ee6cc9e2585268ae91d2.png";